import {Component} from '@angular/core';
import {LoanApplicationService} from '../../loan-application.service';
import {LoanApplication} from '../../../../@models/loan-application.model';
import { ApplicationSourceSelectService } from 'src/app/@modules/application-source-select/application-source-select.service';

@Component({
  selector: 'bb-reference',
  templateUrl: './reference.component.html',
  styleUrls: ['./reference.component.scss'],
})
export class ReferenceComponent {
  constructor(public loan: LoanApplicationService,
              public source: ApplicationSourceSelectService) {
  }

  get invalid() {
    return this.loan.form.get('application_source').dirty && this.loan.form.get('application_source').hasError('required');
  }
}
